export default __webpack_public_path__ + "static/media/banner-min.d7bfdf66.png";